<template>
  <div class="caseDetail">
    <div class="caseDetail-top"></div>
    <div class="caseDetail-content">
      <div class="caseDetail-content-top">
        <span>首页 ></span>
        <span style="color: #00BDB7">案例详情</span>
      </div>
      <div class="caseDetail-content-title">
        <div class="caseDetail-content-one">{{content.title}}</div>
      </div>
      <div class="caseDetail-content-date">{{content.createTime}}</div>
      <div class="caseDetail-content-box">
        <div class="caseDetail-box" v-html="content.text"></div>
      </div>
      <div class="caseDetail-page">
        <div>
          <div
            class="previous"
            v-if="previous"
            style="cursor: pointer;"
            @click="toNext(previous.id)"
          >上一篇：{{previous.title}}</div>
          <div v-else>上一篇：无</div>
        </div>
        <div
          v-if="next"
          style="cursor: pointer;"
          @click="toNext(next.id)"
          class="next"
        >下一篇：{{next.title}}</div>
        <div v-else>下一篇：无</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getOpertionPublicity } from '../api/publicinquiry.api.js';
export default {
  data() {
    return {
      id: '',
      content: {},
      previous: null,
      next: null
    };
  },
  methods: {
    getCaseDetail() {
      let params = {
        id: this.id
      };
      getOpertionPublicity(params).then(res => {
        this.content = res.data;
        this.previous = res.data.reviousAndNext.previous;
        this.next = res.data.reviousAndNext.next;
      });
    },
    toNext(id) {
      // console.log(id);
      this.$router.push({
        name: 'caseDetail',
        params: {
          Id: id
        }
      });
    }
  },
  watch: {
    $route(to, from) {
      this.id = this.$route.params.Id;
      this.getCaseDetail();
    }
  },
  created() {
    this.id = this.$route.params.Id;
    this.getCaseDetail();
  }
};
</script>
<style>
.caseDetail {
  width: 100%;
}
.caseDetail-content {
  width: 1500px;
  margin: auto;
  padding-bottom: 100px;
}
.caseDetail-content-top {
  font-family: '微软雅黑';
  font-weight: 410;
  font-style: normal;
  font-size: 18px;
  line-height: 74px;
  color: #333333;
}
.caseDetail-content-title {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 20px;
  color: #000000;
  line-height: 28px;
  text-align: center;
}
.caseDetail-content-one {
  width: 600px;
  height: 56px;
  margin: auto;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.caseDetail-content-date {
  font-size: 14px;
  color: #666666;
  text-align: right;
  line-height: 36px;
  text-align: right;
}
.caseDetail-content-box {
  width: 1500px;
  border: 1px solid rgba(204, 204, 204, 1);
}
.caseDetail-box {
  margin: auto;
  padding: 40px 40px 90px;
}
/* .caseDetail-box img {
  width: 500px;
  height: 500px;
} */
.caseDetail-page {
  font-family: '微软雅黑';
  font-weight: 410;
  font-style: normal;
  font-size: 18px;
  line-height: 36px;
  color: #333333;
}
.previous,
.next {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
</style>
<style media="screen">
/*分辨率低于1280，采用下面的样式*/
@media screen and (max-device-width: 1500px) {
  .caseDetail-content,
  .caseDetail-content-box {
    width: 1200px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/caseDetail.vue